import { render, staticRenderFns } from "./SQL.vue?vue&type=template&id=c6610ce0&scoped=true&"
import script from "./SQL.vue?vue&type=script&lang=js&"
export * from "./SQL.vue?vue&type=script&lang=js&"
import style0 from "./SQL.vue?vue&type=style&index=0&id=c6610ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6610ce0",
  null
  
)

export default component.exports